<template>
  <v-flex xs12 v-if="taker.info" class="container_taxas">
    <div>
      <!-- Limite Global  -->
      <div class="limits-taxs xs12" v-if="step == 1">
        <v-flex xs12 v-if="step == 1 || tipo_grupo == 'T'">
          <v-layout row wrap>
            <v-flex xs7>
              <v-layout row wrap>
                <v-flex xs1>
                  <v-icon class="icon_blue">check_circle_alt</v-icon>
                </v-flex>
                <v-flex xs11 class="middle text_taxs">
                  Limite global do tomador com data de validade até
                  <span class="red_date" v-html="getValidateDate()"></span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs5>
              <v-layout row wrap>
                <v-flex xs6 class="limit_text">
                  Limite Disponível
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      class="limit_values"
                      v-html="
                        taker.info.limite_disponivel != null
                          ? taker.info.limite_disponivel.toLocaleString(
                              'pt-BR',
                              $settings.moneyFormatOptions
                            )
                          : ''
                      "
                    ></v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 class="limit_text">
                  Limite Total
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      class="limit_values"
                      v-html="
                        taker.info.limite_total_global != null
                          ? taker.info.limite_total_global.toLocaleString(
                              'pt-BR',
                              $settings.moneyFormatOptions
                            )
                          : ''
                      "
                    ></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
      <!-- ./Limite Global -->

      <p></p>

      <!-- Texto header -->
      <div class="limits_util">
        <div
          :class="
            (step == 1 || tipoTaxa == 'PR') && (step == 1 || tipoTaxa == 'PU')
              ? 'xs12'
              : 'xs12'
          "
          class="text-noborder"
        >
          Utilização máxima do limite por grupo de modalidade
        </div>
      </div>
      <!-- ./Texto header -->

      <div class="limits_util">
        <!-- Modalidades  -->

        <div v-for="(grupo, index) in taker.info.grupos_credito" :key="index">
          <div v-if="validateModality(grupo.id_grupo)">
            <v-layout row wrap class="limits-taxs">
              <section class="titulo">
                <v-icon
                  class="icon_blue icon_mouse"
                  v-if="grupo.modalidades.length > 0"
                  @click="
                    tipoModalidade = 'T';
                    openModalTaxa(grupo.modalidades, grupo.nome);
                  "
                  >info</v-icon
                >
                <span class="nome-modalidade">{{ grupo.nome }}</span>
              </section>

              <section class="valores">
                <div class="limit_text middle">
                  <span>Disponível</span>
                  <span class="limit_values">
                    {{
                      grupo.limite_disponivel != null
                        ? grupo.limite_disponivel.toLocaleString(
                            "pt-BR",
                            $settings.moneyFormatOptions
                          )
                        : "R$ 0"
                    }}
                  </span>
                </div>

                <div class="limit_text middle">
                  <span>Uso máximo do limite global (100%)</span>
                  <span class="limit_values">
                    {{
                      grupo.limite_total != null
                        ? grupo.limite_total.toLocaleString(
                            "pt-BR",
                            $settings.moneyFormatOptions
                          )
                        : "R$ 0"
                    }}
                  </span>
                </div>

                <div class="limit_text middle">
                  <span v-if="step == 1 || tipoTaxa == 'PR'"
                    >Taxa para segurado privado</span
                  >
                  <span v-if="step == 1 || tipoTaxa == 'PU'"
                    >Taxa para segurado público</span
                  >
                  <span
                    class="limit_values"
                    v-if="step == 1 || tipoTaxa == 'PR'"
                  >
                    {{ grupo.taxa_segurado_privado }}%
                  </span>

                  <span
                    class="limit_values"
                    v-if="step == 1 || tipoTaxa == 'PU'"
                  >
                    {{ grupo.taxa_segurado_publico }}%
                  </span>
                </div>
              </section>
            </v-layout>
          </div>
        </div>
        <!-- ./Modalidades  -->
      </div>

      <span
        v-if="step == 1 && this.taker.info.cadastro_revisado == 'NAO_REVISADO'"
        class="warn_text"
        >Limite pré-aprovado e provisório, pode estar aquém da capacidade do
        tomador.</span
      >
      <br />
      <span
        v-if="step == 1 && this.taker.info.cadastro_revisado == 'NAO_REVISADO'"
        class="warn_text"
        >Para aprovação do limite, prossiga com a inserção da proposta.</span
      >
    </div>
    <!-- ./Limite maximo -->

    <v-dialog v-model="modalTaxa" persistent :max-width="'520'">
      <base-modal>
        <h2 class="title" v-html="`Modalidades ${nomeGrupoDaModalidade}`"></h2>

        <!-- <h2 v-if="tipoModalidade=='G'" class="title">Aviso</h2>
        <h3 v-if="tipoModalidade=='G' && this.taker.info.cadastro_revisado == 'NAO_REVISADO'">
          O limite global do tomador é o valor máximo que o tomador
          pode acumular em importâncias seguradas junto a JNS,
          somando-se todas as suas apólices de todas as modalidades.
        </h3>-->
        <div>
          <div class="modalidade">
            <v-layout
              v-for="(modalidade, index) in modalidades"
              :key="index"
              row
              wrap
            >
              <span class="modalidades">{{ modalidade.nome }}</span>
            </v-layout>
          </div>
        </div>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="closeModalTaxa()"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </v-flex>
</template>


<script lang="js">
import { VMoney } from "v-money";
export default {
  name: "TaxasLimites",
  data: () => ({
    taxAndlimitsToolTip: false,
    tipoModalidade: "T",
    tipo_grupo: "T",
    modalTaxa: false,
    modalidades: [],
    nomeGrupoDaModalidade: "",
  }),
  props: ["taker", "step", "tipo_pessoa", "id_grupo"],
  computed: {
    tipoTaxa() {
      if (this.tipo_pessoa == "ORGAO_PUBLICO" || this.tipo_pessoa == "FISICA") {
        return "PU";
      } else {
        return "PR";
      }
    },
  },
  methods: {
    openModalTaxa(modalidades, nome) {
      this.modalidades = modalidades;
      this.nomeGrupoDaModalidade = nome;
      this.modalTaxa = true;
    },
    closeModalTaxa() {
      this.modalidades = [];
      this.modalTaxa = false;
    },
    closeToolTip() {
      this.taxAndlimitsToolTip = false;
    },
    getValidateDate() {
      if (this.taker.info.data_validade_limite) {
        let date = this.taker.info.data_validade_limite;
        let year = date.toString().substring(0, 4);
        let month = date.toString().substring(5, 7);
        let day = date.toString().substring(8, 10);
        return `${day}/${month}/${year}`;
      } else {
        return "sem data";
      }
    },
    validateModality(id_grupo) {
      if (this.step == 4) {
        return id_grupo == this.id_grupo;
      } else {
        return true;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
#jns {
  $blue_color: #282498;
  .container_taxas {
    .limits_util {
      display: flex;
      flex-direction: column;
    }
  }

  .icon_mouse {
    cursor: help;
  }

  .info-red {
    color: #d21a5e;
  }

  .warn_text {
    font-size: 0.7vw;
    line-height: 0ch;
    color: #d21a5e;
  }

  .icon_blue {
    color: $blue_color;
    margin-top: 15px;
    margin-left: 5px;
  }

  .container_taxas {
    margin: 0px;
    padding: 0px;
  }

  .modalidades {
    padding-left: 20px;
    font-size: 8pt;
    line-height: 1ch;
    padding-top: 5px;
    padding-bottom: 10px;
  }
  .modalidade {
    padding-top: 10px;
  }

  .limits-taxs {
    border-collapse: collapse;
    border: 1px solid #dfdfdf;
    border-radius: 1px;
    background-color: #f7f7f7;
    flex-wrap: wrap;

    .titulo {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
      margin: 1% auto 0 auto;
      text-align: center;

      .v-icon {
        margin: 0 1px 0 0;
      }

      .nome-modalidade {
        padding-top: 2px;
        font-size: 0.875rem;
      }
    }

    .valores {
      display: flex;
      width: 90%;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 auto 1% auto;

      .limit_text {
        display: flex;
        flex-direction: column;
        font-size: 0.7rem;
        align-items: center;
      }
    }

    .text-limit-values {
      text-align: right;
      min-width: 60px;
      width: 120px;
    }
    .end {
      padding-right: 10px;
    }
    .middle {
      padding-top: 20px;
    }

    .limit_text {
      font-size: 0.65vw;
      text-align: right;
      font-weight: 900;
    }

    .limit_values {
      font-size: 11px;
      text-align: right;
      color: #d21a5e;
    }
  }

  .text_taxs {
    font-size: 0.9vw;
    text-align: left;
  }

  .center {
    text-align: center;
  }

  .values_taxs {
    padding-top: 30px;
    font-size: 1vw;
    text-align: center;
    font-weight: 500;
  }

  .limits-taxs-max {
    border-collapse: collapse;
    //border: 1px solid #dfdfdf;
    border-radius: 1px;
    background-color: #f7f7f7;
    margin-top: -1px;

    .tr-noborder {
      border: 0px solid white;
      background-color: white;
    }

    .text-init {
      width: 270px;
      padding-left: 5px;
      border-left: 1px solid #dfdfdf;
      border-bottom: 1px solid #dfdfdf;
    }
    .text-values {
      font-size: 8pt;
      text-align: right;
      width: 130px;
    }
    .text-values-more {
      font-size: 8pt;
      text-align: right;
      width: 130px;
      max-width: 130px;
    }
    .row-border {
      border-top: 1px solid #dfdfdf;
    }
    .end-values {
      border-bottom: 1px solid #dfdfdf;
    }
  }

  .text-noborder {
    font-size: 1rem;
    font-weight: 900;
    text-align: center;
    color: #fff;
    text-shadow: 1px solid rgba($color: #000000, $alpha: 0.2);
  }

  .space {
    width: 15px;
    text-align: center;
  }

  .taxs-cells {
    border: 1px solid #dfdfdf;
    background-color: #f7f7f7;
    margin: 5px;
    padding: 5px;
    font-size: 8pt;
    text-align: center;
    width: 150px;
  }

  .taxs-cells-header {
    border: 1px solid #dfdfdf;
    background-color: #f7f7f7;
    margin: 5px;
    padding: 5px;
    font-size: 8pt;
    text-align: center;
  }

  .limits-red-values {
    width: 75px;
    text-align: right;
    &.end {
      text-align: left;
    }
  }

  .taxs-cells-header-init {
    border: 1px solid #dfdfdf;
    background-color: #f7f7f7;
    margin: 5px;
    padding: 5px;
    font-size: 8pt;
    text-align: center;
    // width: 114px;
    border-right: none;
  }

  .pad-value {
    padding-right: 5px;
  }

  .red_date {
    color: #d21a5e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TaxasLimites.vue